export const deleteFiles = (section: HTMLElement) => {
    const files = section.querySelectorAll('.content__file') as NodeListOf<HTMLElement>
    const number = section.querySelector('.content__nbrPictures .number') as HTMLSpanElement

    files?.forEach((file) => {
        (file.querySelector('a') as HTMLAnchorElement)?.addEventListener('click', () => {
            fetch(`/ajax/fichier/${file.getAttribute('data-id')}/suppression`,
                {
                    method: "POST",
                })
                .then(response => response.json())
                .then(() => {
                    file.remove()


                    if (number) {
                        const newNumber = (section.querySelectorAll('.content__file') as NodeListOf<HTMLElement>).length
                        number.innerText = String(newNumber)

                        if (newNumber < Number(section.getAttribute('data-limit'))) {
                            const upload = section.querySelector('.content__upload') as HTMLElement
                            const input = upload?.querySelector('input') as HTMLInputElement
                            const uploadSpace = upload?.querySelector('.upload-space') as HTMLElement
                            uploadSpace?.classList.remove('hidden')
                            input?.removeAttribute('disabled')
                        }
                    }
                })
                .catch(error => {
                    console.error("Erreur lors de la requête:", error);
                });
        })
    })

}
